import { Component, Inject, Input, OnInit } from '@angular/core';
import { oc } from 'ts-optchain';
import { Employee, EmployeeView, LoggerService } from '../../../../shared/sdk';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { LoopBackStoreOptions } from '../../../../shared/classes/loopback-custom-store/generic/store-options/LoopBackStoreOptions';
import CustomStore from 'devextreme/data/custom_store';
import { headersAllTenantsAppend } from '../../../../shared/classes/utils/utils';

@Component({
  selector: 'app-dlg-select-driver',
  templateUrl: './dlg-select-driver.component.html',
  styleUrls: ['./dlg-select-driver.component.scss'],
})
export class DlgSelectDriverComponent implements OnInit {
  @Input() ds: DataSourceOptions;
  @Input() gridColumns: any[] = [
    { dataField: 'person_firstname', caption: 'Firstname' },
    { dataField: 'person_lastname', caption: 'Lastname' },
    { dataField: 'facility_shortname', caption: 'Facility' },
    { dataField: 'status', caption: 'Status' },
  ];

  @Input() gridSelection = { mode: 'single', showCheckBoxesMode: 'none' };
  @Input() gridPaging = { enabled: true, pageSize: 10 };
  @Input() gridFilterRow = { visible: true };
  @Input() gridScrolling = { mode: 'infinite' };

  constructor(
    private dialogRef: MatDialogRef<DlgSelectDriverComponent, any>,
    @Inject(MAT_DIALOG_DATA)
    private data: {
      skipTenantCheck: boolean;
      filter: any;
    },
    protected logger: LoggerService,
    private dss: DataSourceService,
  ) {}

  ngOnInit() {
    this.buildDataSource();
  }

  private buildDataSource() {
    const so = this.dss.getStoreOptions(Employee, EmployeeView, false) as LoopBackStoreOptions<any, any>;
    if (this.data.skipTenantCheck) {
      so.customHeaders = headersAllTenantsAppend;
    }
    so.customFilter = {
      where: oc(this.data).filter({ state: 'ACTIVE' }),
      order: ['person_lastname ASC'],
    };

    this.ds = {
      store: new CustomStore(so),
    } as DataSourceOptions;
  }

  grid_onSelectionChanged(e) {}
}
